<template>
  <div @click.stop :class="{ opened: !!value }" class="side-message">
    <v-btn class="close" icon @click="$emit('input', false)">
      <v-icon color="white">$close</v-icon>
    </v-btn>
    <div class="side-message__container" v-if="value">
      <div class="side-message__title">{{ value.title }}</div>

      <div v-html="value.description"></div>
      <v-btn target="_blank" :href="value.link_to" color="white" large>
        <span style="line-height: 30px;height: 24px;">
          {{ value.link_text }}
        </span>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: [Object, Boolean],
  },
};
</script>

<style scoped lang="scss">
.side-message {
  position: fixed;
  right: -350px;
  top: 0;
  bottom: 0;
  width: 350px;
  background: #00b999;
  z-index: 999;
  padding: 40px;
  color: white;
  font-weight: 500;
  font-size: 18px;
  text-align: center;
  display: flex;
  align-items: center;
  transition: 0.5s;

  &__container {
    width: 100%;
  }

  &.opened {
    right: 0;
  }
  .close {
    margin: 0 !important;
  }

  &__title {
    font-weight: 900;
    font-size: 48px;
    color: white;
    line-height: 1.1;
    margin-bottom: 20px;
    text-transform: uppercase;
  }

  .v-btn {
    margin-top: 40px;
  }
}

@media screen and (max-width: 960px) {
  .side-message {
    display: none;
  }
}
</style>
